import { cx } from '@emotion/css';
import { PlayArrowRounded } from '@mui/icons-material';
import { Button, Loader } from '@sortlist-frontend/design-system/legacy';
import { createRef, FC, Fragment, useState } from 'react';

import * as S from './styles';

export type Props = {
  url: string;
  title?: string;
  placeholder?: string;
  height?: string;
  allowFullScreen?: boolean;
};

const defaultIframefeatures =
  'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';

export const YoutubeEmbed: FC<Props> = (props) => {
  const { url, title, placeholder, height, allowFullScreen } = props;
  const [isPlayed, setIsPlayed] = useState<boolean>(false);
  const [videoUrl, setVideoUrl] = useState<string>(url);
  const iframeRef = createRef<HTMLIFrameElement>();

  const handlePlay = () => {
    if (iframeRef.current) {
      setIsPlayed(true);
      setVideoUrl(url + '?autoplay=1');
    }
  };

  return (
    <S.YouTubeEmbed
      isPlayed={isPlayed}
      placeholder={placeholder}
      className="rounded-xl cursor-pointer"
      data-testid="story-youtube-embed"
      onClick={handlePlay}>
      {!isPlayed && (
        <S.PlayFab className="absolute">
          <Button
            fab={true}
            size={'sm'}
            onClick={handlePlay}
            buttonVariant={'light'}
            buttonStyle={'secondary'}
            icon={<PlayArrowRounded style={{ fontSize: 24 }} />}
            id="play-youtube-btn"
          />
        </S.PlayFab>
      )}
      <S.Iframe
        ref={iframeRef}
        className="rounded-xl"
        width="100%"
        height={height || '484'}
        src={videoUrl}
        title={title || ''}
        allow={allowFullScreen ? `${defaultIframefeatures}; fullscreen` : defaultIframefeatures}></S.Iframe>
    </S.YouTubeEmbed>
  );
};
